import React from "react";
import { Check, X } from "react-feather";
import { toast } from "react-toastify";
import styles from "./Toast.module.css";
import "react-toastify/dist/ReactToastify.css";

toast.configure();
const toastSuccess = (text: string) => {
  toast(
    <>
      <div className={styles.toast_wrapper}>
        <div className={styles.icon_wrapper}>
          <Check color="#7dc554" size={40} />
        </div>
        {text}
      </div>
      <div className={`${styles.footer} ${styles.success}`} />
    </>,
    {
      className: styles.no_background,
      position: "top-right",
      autoClose: 6000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    }
  );
};

const toastError = (text: string) => {
  toast(
    <>
      <div className={styles.toast_wrapper}>
        <div className={styles.icon_wrapper}>
          <X color="#fb3049" size={40} />
        </div>
        Error: {text}
      </div>
      <div className={`${styles.footer} ${styles.error}`} />
    </>,
    {
      position: "top-right",
      autoClose: 6000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    }
  );
};

const sendToast = (text: string, type: "error" | "success") => {
  if (type === "error") {
    toastError(text);
  }
  if (type === "success") {
    toastSuccess(text);
  }
};

export default sendToast;
